<template>
  <div class="picture-viewer">
    <div
      ref="zoomContainer"
      class="zoomable"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @wheel.prevent="onWheelZoom"
      @mousedown="onDragStart"
      @mousemove="onDragMove"
      @mouseup="onDragEnd"
      @mouseleave="onDragEnd"
      @touchstart.passive="onDragStartTouch"
      @touchmove.passive="onDragMoveTouch"
      @touchend="onDragEnd"
    >
      <img
        ref="zoomImg"
        :style="imageStyle"
        :src="$anm22.getImagePath(picToShow, false)"
        @load="calculateMinScale"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    picToShow: [String],
  },
  data() {
    return {
      scale: 1,
      lastScale: 1,
      startDistance: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      translateX: 0,
      translateY: 0,
    };
  },
  computed: {
    imageStyle() {
      return {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        objectPosition: "center",
        cursor: this.scale > this.minScale ? "grab" : "default",
        transition: this.isDragging ? "none" : "transform 0.2s ease-out",
        transform: `scale(${this.scale}) translate(${this.translateX}px, ${
          this.translateY
        }px)`,
      };
    },
  },
  methods: {
    calculateMinScale() {
      this.minScale = 1;
      this.scale = this.minScale;
    },
    getDistance(touches) {
      const [touch1, touch2] = touches;
      return Math.sqrt(
        Math.pow(touch2.pageX - touch1.pageX, 2) +
          Math.pow(touch2.pageY - touch1.pageY, 2)
      );
    },
    onTouchStart(event) {
      if (event.touches.length === 2) {
        this.startDistance = this.getDistance(event.touches);
        this.lastScale = this.scale;
      }
    },
    onTouchMove(event) {
      if (event.touches.length === 2) {
        const newDistance = this.getDistance(event.touches);
        const scaleChange = newDistance / this.startDistance;
        this.scale = Math.max(
          this.minScale,
          Math.min(3, this.lastScale * scaleChange)
        );
      }
    },
    onTouchEnd() {
      if (this.scale < this.minScale) {
        this.scale = this.minScale;
      }
    },
    onWheelZoom(event) {
      if (event.ctrlKey) {
        // Il browser usa Ctrl+Scroll per lo zoom
        event.preventDefault();
        const delta = event.deltaY > 0 ? -0.1 : 0.1;
        this.scale = Math.max(this.minScale, Math.min(3, this.scale + delta));

        if (this.scale === this.minScale) {
          this.translateX = 0;
          this.translateY = 0;
        }
      }
    },
    onDragStart(event) {
      if (this.scale > this.minScale) {
        // Abilita drag solo se l'immagine è ingrandita
        this.isDragging = true;
        this.dragStartX = event.clientX * (1 / this.scale) - this.translateX;
        this.dragStartY = event.clientY * (1 / this.scale) - this.translateY;
        event.preventDefault(); // Evita selezione indesiderata
      }
    },
    onDragMove(event) {
      if (this.isDragging) {
        this.translateX = event.clientX * (1 / this.scale) - this.dragStartX;
        this.translateY = event.clientY * (1 / this.scale) - this.dragStartY;
      }
    },
    onDragEnd() {
      if (this.scale < this.minScale) {
        this.scale = this.minScale;
      }
      this.isDragging = false;
    },
    onDragStartTouch(event) {
      if (this.scale > this.minScale && event.touches.length === 1) {
        this.isDragging = true;
        this.touchStartX =
          event.touches[0].clientX * (1 / this.scale) - this.translateX;
        this.touchStartY =
          event.touches[0].clientY * (1 / this.scale) - this.translateY;
        event.preventDefault();
      }
    },
    onDragMoveTouch(event) {
      if (this.isDragging && event.touches.length === 1) {
        this.translateX =
          event.touches[0].clientX * (1 / this.scale) - this.touchStartX;
        this.translateY =
          event.touches[0].clientY * (1 / this.scale) - this.touchStartY;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-viewer {
  width: 100%;
  height: 100%;
}
.zoomable {
  touch-action: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
</style>
